<template>
    <div>
        <v-text-field :type="type" :name="name" :label="label" :v-validate="validate" v-model="text"
                      @change="onInput" ref="ctrl"
                      :placeholder="placeholder" :maxlength="maxLength" data-vv-scope="createForm" :autofocus="autofocus" :error="error"
                      :error-messages="errorMessage"
        />
        <!--div style="color:red">{{errorMessage}}</div-->
    </div>
</template>

<script>
    export default {
        name: 'c-textbox',
        inheritAttrs: false,
        props: {
            icon: {
                type: String,
                default: 'Table'
            },
            autofocus:{
                type: Boolean,
                default:false
            },
            type: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            validate: {
                type: String,
                default: ''
            },
            maxLength: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String
            },
            value: {
                type: String,
                default: ''
            }
        },
        watch: {
            value: function (data) {
                this.text = data;
                this.error = false;
                this.errorMessage = [];
            },
            error: function (data) {
                this.error = data;
            }
        },

        data:()=>{
            return {
                text:null,
                error:false,
                errorMessage:[]
            }
        },

        methods: {
            onInput: function (target) {
                this.$emit('input', target);
            },

            focus:function(){
                this.$refs.ctrl.focus();
            }
        }
    }
</script>
